export default __webpack_public_path__ + "static/media/Portwest-Australian-Catalogue-2021-3-1-400x482.b043f862.jpg";